export default function SocialWordpress() {
  return (
    <div
      className="ion-icon-social-wordpress"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M259,271.3L226.2,367h-0.1l-25.4,73.1c1.8,0.5,3.5,0.9,5.3,1.4c0.1,0,0.2,0,0.3,0c15.8,4.2,32.4,6.5,49.5,6.5
		c8.5,0,16.8-0.5,24.9-1.8c11.2-1.4,22-3.8,32.5-7.1c0,0,0,0,0,0c2.6-0.8,5.2-1.7,7.8-2.6c-2.8-6-8.8-19.3-9.1-19.9L259,271.3z"/>
	<path d="M80.8,180.5c-10,22.6-16.8,50.4-16.8,75.5c0,6.3,0.3,12.6,0.9,18.8c6.9,71.2,52.9,131,116.1,157.9c2.6,1.1,5.3,2.2,8,3.2
		L96,180.6C88,180.3,86.5,180.8,80.8,180.5z"/>
	<path d="M430.2,175.4c-4.3-9.3-9.4-18.2-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2c-21.5-28.8-50.8-51.4-84.9-64.6
		C303.7,68.6,280.3,64,255.9,64c-60.3,0-114.2,28-149.4,71.7c-6.5,8-12.3,16.6-17.5,25.6c14.2,0.1,31.8,0.1,33.8,0.1
		c18.1,0,46-2.2,46-2.2c9.4-0.6,10.4,13.1,1.1,14.2c0,0-9.4,1.1-19.8,1.6l62.9,187l37.8-113.3L224,175.1c-9.4-0.5-18.1-1.6-18.1-1.6
		c-9.4-0.5-8.2-14.8,1-14.2c0,0,28.5,2.2,45.5,2.2c18.1,0,46-2.2,46-2.2c9.3-0.6,10.5,13.1,1.1,14.2c0,0-9.3,1.1-19.7,1.6
		l62.3,185.6l17.3-57.6c8.7-22.4,13.1-40.9,13.1-55.7c0-21.3-7.7-36.1-14.3-47.6c-8.7-14.3-16.9-26.3-16.9-40.4
		c0-15.9,12-30.7,29-30.7c0.7,0,1.5,0,2.2,0c26.2-0.7,34.8,25.3,35.9,43c0,0,0,0.4,0,0.6c0.4,7.2,0.1,12.5,0.1,18.8
		c0,17.4-3.3,37.1-13.1,61.8l-39,112.8l-22.3,65.7c1.8-0.8,3.5-1.6,5.3-2.5c56.7-27.4,98-82,106.7-146.7c1.3-8.5,1.9-17.2,1.9-26
		C448,227.3,441.6,199.9,430.2,175.4z"/>
</g>
</svg>
`,
      }}
    />
  )
}
